module.exports = __webpack_public_path__ + "static/media/lecturer3.955c86db.jpg";